import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.css'
import App from './App';
import reportWebVitals from './reportWebVitals';



// import 'bootstrap/dist/js/bootstrap.bundle.min';
import { PersistGate } from 'redux-persist/integration/react';
import store from './store';
import { persistor } from './store';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { ApiProvider } from './api/contexts/ApiContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID : '',
      userPoolId: process.env.REACT_APP_USER_POOL_ID ? process.env.REACT_APP_USER_POOL_ID : '',
    }
  },
});

root.render(
  <React.StrictMode>
    <PersistGate loading={null} persistor={persistor}>
      <Provider store={store}>
        <App />
      </Provider>
    </PersistGate>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
